import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const ContentSkeleton = () => {
  const { colors } = useTheme();

  return (
    <ContentLoader
      speed={2}
      width={800}
      height={600}
      viewBox="0 0 800 600"
      backgroundColor={colors.neutral[50]}
      foregroundColor={colors.neutral[20]}
    >
      <rect x="52" y="6" rx="3" ry="3" width="200" height="10" />
      <rect x="51" y="26" rx="3" ry="3" width="152" height="6" />
      <rect x="0" y="64" rx="3" ry="3" width="410" height="6" />
      <rect x="0" y="80" rx="3" ry="3" width="380" height="6" />
      <circle cx="20" cy="20" r="20" />
    </ContentLoader>
  );
};
